import TokenManager from "./tokenGenerator";

/* eslint-disable import/prefer-default-export */
export function GetNetWorkHeaders(persistItemsReducer = {}) {
    const headers = {
      Authorization: `Bearer ${persistItemsReducer?.accessToken}`,
       SOCode: persistItemsReducer?.selectedSOData?.soCode ,
    };
    return headers;
}

/**
 * Creates request headers, ensuring the access token is valid by refreshing it if needed.
 * @param {object} persistItemsReducer - The persisted state from Redux.
 * @param {object} loginReducer - The login state from Redux.
 * @param {function} dispatch - The Redux dispatch function.
 * @returns {Promise<object>} A promise that resolves to the authorization headers.
 */
export async function getHeadersWithTokenRefresh(persistItemsReducer, loginReducer, dispatch, navigate) {
    const secretKey = process.env.REACT_APP_SECRET_KEY;
    const tokenManager = new TokenManager(
        loginReducer?.getSOConfiguration?.loginModule,
        secretKey,
        dispatch,
        persistItemsReducer,
        loginReducer,
        navigate
    );
    return await tokenManager.getAuthHeaders();
}
  